$(document).ready(function() {
    $("#footer-subscribe-newsletter-form").submit(function(e) {
        var self = this;
        e.preventDefault();

        var url = $(this).data('url');
        $.post(url, $("#footer-subscribe-newsletter-form").serialize())
            .success(function() {
                $(self).parent().addClass("success");
                $(self).parent().removeClass("fail");
            })
            .fail(function() {
                $(self).parent().addClass("fail");
            });
    });
});



// WEBPACK FOOTER //
// ./Views/Sites/shared/v2/assets/js/newsletter.js